module.exports = __webpack_public_path__ + "media/src/images/received_gifts/bnr-nologin-saveimg-e1e83522266d124c7ec76d5a66b3a125.svg";